import {useTranslation} from "react-i18next";
import {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";

import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActionsFree";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import FilterModel from "components/FilterModel";
import ItemsModel from "core/itemsModel";
import ButtonsActions from "views/utils/buttonsActions";
import LoaderSpinner from "context/LoaderSpinner";
import FleetRoutesFilters from "./routes/FleetRoutesFilters";
import TableFleetRoutes from "./routes/TableFleetRoutes";
import navs from "./navs";
import axiApi from "ApiCaller";

const ViewFleetRoutes = () => {
    const {t: _Tr} = useTranslation("routes");
    const navigate = useNavigate();

    const bread = useMemo(() => [
        {name: _Tr("labels.fleet-management"), url: "/fleet-management/", current: false},
        {name: _Tr("labels.fleet-routes"), current: true},
    ], [_Tr]);

    const title = _Tr("labels.fleet-routes");
    document.title = title;

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());

    const [buttonsTB, setButtonsTB] = useState({...new ButtonsActions(), title: document.title});
    const [itemsShow, setItemsShow] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = title;
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.filter.active = true;
        buttons.filter.disabled = false;
        buttons.filter.onClick = onClickFilter;
        setButtonsTB(buttons);
        items.current.setItem = () => {};
        items.current.setShowPrev = () => {};
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchRoutes();
        };
        fetchGetRoutes();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        fetchRoutes();
    };

    const onClickFilter = () => {
        const buttons = {...buttonsTB};
        buttons.filter.click = !buttonsTB.filter.click;
        setButtonsTB(buttons);
    };

    const fetchGetRoutes = () => {
        setIsLoading(true);
        axiApi
            .get("/api/fleet/routes/")
            .then((resp) => {
                if (resp.data) {
                    items.current.showed = [...resp.data.items];
                    items.current.all = [...resp.data.items];
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchRoutes = () => {
        setIsLoading(true);
        const body = {
            ...filters.current.chosen,
            download_type: filters.current.download_type,
            waste_type: filters.current.waste_type,
            start: filters.current.start,
            end: filters.current.end,
        };
        axiApi
            .post("/api/fleet/routes/", body, {
                params: pagerModelRef.current.paging.getParams(),
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.showed = [...resp.data.items];
                    items.current.all = [...resp.data.items];
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickEdit = () => {
        if (items.current.chosen.length > 1 || items.current.chosen.length === 0) {
            return false;
        }
        let route = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        if (route) {
            navigate(`/fleet-management/routes/${route.id}/`);
        }
    };

    const applyFilters = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        fetchRoutes();
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} className="sticky-top" style={{top: "72px"}} />
            <div className="row mb-3">
                <div className="col-12">
                    <FleetRoutesFilters
                        filters={filters}
                        show={buttonsTB.filter.click}
                        applyFilters={applyFilters}
                        setItemsShown={setItemsShow}
                        isLoading={isLoading}
                    />
                </div>
            </div>
            <TopBarPagination
                pagerModel={pagerModelRef.current}
                stickyTopValue="125px"
                chosen={items.current.chosen}
            />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableFleetRoutes
                            items={items}
                            itemsShow={itemsShow}
                            setItemsShow={setItemsShow}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                        />
                    </LoaderSpinner>
                </div>
            </div>
        </>
    );
};
export default ViewFleetRoutes;
